import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { firebaseConnect } from 'react-redux-firebase'
import filter from 'lodash/filter';
import find from 'lodash/find';
import * as folioActions from '../../actions/folio-actions';
import CrewMenu from '../../components/CrewMenu/CrewMenu';
import SimpleSpinner from '../../components/SimpleSpinner/SimpleSpinner';
import Story from '../../components/Story/Story';
import Section from '../../components/Section/Section';
import styled from 'styled-components';
import smoothScroll from '../../utility/smoothScroll';

import PropTypes from 'prop-types';

import '../../styles.scss';

class InsideContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showExtended: false
    };
  }

  handleClick = () => {
    this.setState(() => ({ showExtended: false }))
  };

  render() {
    const isMobile = window.innerWidth < 769; //(/Mobi((?!iPad).)*$/.test(navigator.userAgent));
    const allStories = this.props.stories && filter(this.props.stories, { section: 'about'})
        .sort((a,b) => (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0)) || [];
    const selectedStory = allStories && filter(allStories, { path: this.props.match.params.name })[0] || [];
    const selectedSection = find(this.props.sections, { name: this.props.section });
    let sidebarPhoto = selectedStory && this.state.showExtended ?
        filter(selectedStory.media, (item) => item.tag && item.tag.toLowerCase().includes('secondary') ) :
        filter(selectedStory.media, (item) => item.tag && item.tag.toLowerCase().includes('main') );
    sidebarPhoto = selectedStory && isMobile ?
        filter(selectedStory.media, (item) => item.tag && item.tag.toLowerCase().includes('mobile')) : sidebarPhoto;
    const backgroundImage = filter(selectedStory.media, (item) => item.tag && item.tag.toLowerCase().includes('background') );
    const transitionProperties = {
      transitionName: "fadein",
      transitionAppear: true,
      transitionAppearTimeout: 3000,
      transitionEnterTimeout: 3000,
      transitionLeaveTimeout: 3000,
      transitionEnter: true,
      transitionLeave: true,
      key: 1
    };

    const icon =
        <svg style={ { margin: '0 auto', display: 'block', transform: 'translateX(10px)' }} width="100px" height="100px" viewBox="0 0 200 200">
          <path className="birdPath"
                fill="transparent"
                stroke="#f9e7cc"
                strokeDasharray="20"
                strokeWidth="3"
                d="M41,41s-5.544,20.4-8,30c-6.432,25.145-2.365,34.289,13,49,19.126,18.312,20.681,27.827,22,32,1.1,3.478-2.431,10.124-4,13-0.137,3.078.853,7.475,0,9-2.922.916-17.657,6.913-19,30,15.367-17.461,13.617-10.677,19-14,5.324-2.959,6.028-7.064,8-11,2.464-4.211,4.866-6.919,8-9,8.634-3.147,28.663.387,39,6s14.786,9.353,26,10,24.625-3.761,32-6a285.393,285.393,0,0,1,33-8c2.934-1.22-8.5-1.49-15-1-6.053.456-11.58,0.887-14,0-2.824-1.035-6.151-3.607-4-4s1.051-2.63-1-3c-2.876-.518-8.821,3.214-10,0s3.612-9.722,3-11-4.291,4.947-6,5c-3.553.111-9.662-3.29-11-3-0.754.164-7.021,2.952-7-3,0.027-7.847.727-13.1,8-22s14.634-21.371,21-27,16.186-8.258,16-11-4-2-4-2-10.736,6.853-13,5,6.962-16.514,7-20-3.109,1.786-13,5c-1.073.349-2.933,2.785-5,8-7.448,10.69-11,19.04-21,28s-31.9,13.945-36,14a25.861,25.861,0,0,1-10-2c-2.978-1.362-5.231-3.889-6-4-1.664-.24-5.167.718-7,0s-0.562-5.077-2-9a5.77,5.77,0,0,0-5-4l-5-10s-2.982-13.342-6-16c-1.717-1.512-6.262-.375-7-1s-1.43-14.334-2-17-6.663.091-7-2S48.214,37.921,41,41Z"
                transform="translate(-29.767 -40.424)"
          />
    </svg>;

    const Inside = styled.div`
      margin-top: 100px;
      
      & + .bottom-rail {
        display: none !important;
      }
    `;

    return (
        <Inside className="inside-chevo">
          { allStories.length > 0 ?
          <div className="section-wrapper">
            { !this.props.match.params.name ?
                <Section transitionProperties={ transitionProperties }
                         icon={ icon }
                         copy={ selectedSection && selectedSection.body }
                         intro={ selectedSection && selectedSection.intro }
                />
                : <Story allStories={ allStories }
                         backgroundImage={ backgroundImage }
                         isMobile={ isMobile }
                         menuTitle="Meet the Crew"
                         handleClick={ this.handleClick }
                         menuHighlight={ !this.props.match.params.name }
                         selectedStory={ selectedStory }
                         sidebarPhotos={ sidebarPhoto }
                         sectionName="inside-chevo"
                         showExtended={ this.state.showExtended }
                         handleShowMore={ () => { this.setState(() => ({ showExtended: !this.state.showExtended }), () => {
                           setTimeout(() => { smoothScroll.scrollTo('extendedStory') }, 1000);
                         })  } }
                />
             }

          </div> : <SimpleSpinner /> }
          <CrewMenu highlight={ !this.props.match.params.name  } title="Meet the crew" isMobile={ isMobile } allStories={ allStories } handleClick={ this.handleClick } />
        </Inside>

    );
  }
}

InsideContainer.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['stories', 'sections']),
    connect(
        (state) => ({
          inside: state.inside,
          stories: state.firebase.data.stories,
          sections: state.firebase.data.sections,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(InsideContainer)



// WEBPACK FOOTER //
// ./src/containers/inside-chevo/inside.js